export const PAID_API_LIMIT_MESSAGE =
  'Limite d’utilisation atteinte pour aujourd’hui. Réessayez demain.'

export function paidApiLimitStatus(error) {
  return Number(error?.response?.status ?? error?.status ?? 0) === 429
}

export function paidApiLimitMessage(error) {
  if (paidApiLimitStatus(error)) return PAID_API_LIMIT_MESSAGE
  return ''
}
